import {
  UPDATE_ASSIGMENTS_ORDER_DETAIL,
  UPDATE_ASSIGMENTS_ORDER_DETAIL_ERROR,
} from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const updateOrderLineAssignmentAction = (params) => async (dispatch) => {
  const { legal_id, order_id, body } = params || {};

  console.log('UPDATE ORDER FROM ACTION', legal_id, order_id, body);

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.put(
      `/api/companies/${legal_id}/linked-up/orders/${order_id}/details`,
      body,
    );

    const { data, status } = response || {};

    dispatch({
      method: 'put',
      payload: data || {},
      status: status || {},
      type: UPDATE_ASSIGMENTS_ORDER_DETAIL,
    });
  } catch (e) {
    dispatch({
      method: 'put',
      payload: e || {},
      type: UPDATE_ASSIGMENTS_ORDER_DETAIL_ERROR,
    });
  }
};
